export default ['0px', '1px', '2px', '4px', '10px'];
